/**
 * useBanks Hook
 * 
 * Custom hook for fetching and managing banks data.
 */

import * as React from "react";
import { bankService, type Bank } from "@/services/bankService";

export function useBanks() {
  const [banks, setBanks] = React.useState<Bank[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  const fetchBanks = React.useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const data = await bankService.getAllBanks();
      setBanks(data);
    } catch (err) {
      console.error("Error fetching banks:", err);
      setError(err instanceof Error ? err.message : "Gagal memuat data bank");
      setBanks([]);
    } finally {
      setLoading(false);
    }
  }, []);

  React.useEffect(() => {
    fetchBanks();
  }, [fetchBanks]);

  return {
    banks,
    loading,
    error,
    fetchBanks,
  };
}

